module.exports = __webpack_public_path__ + "img/gh-36330m.asm.dbe9b859.jpg";